import { useCallback, useRef } from "react";

/**
 * Card whose border glow follows the pointer.
 *
 * The gradient position lives in CSS custom properties rather than React
 * state: pointermove would otherwise re-render the whole grid at 60fps.
 */
function SpotlightCard({ as: Tag = "div", className = "", children, ...rest }) {
  const ref = useRef(null);
  const frame = useRef(0);

  const onPointerMove = useCallback((event) => {
    const el = ref.current;
    if (!el || frame.current) return;
    const { clientX, clientY } = event;
    frame.current = requestAnimationFrame(() => {
      frame.current = 0;
      const rect = el.getBoundingClientRect();
      el.style.setProperty("--mx", `${clientX - rect.left}px`);
      el.style.setProperty("--my", `${clientY - rect.top}px`);
    });
  }, []);

  return (
    <Tag ref={ref} className={`scard ${className}`.trim()} onPointerMove={onPointerMove} {...rest}>
      <div className="scard__inner">{children}</div>
    </Tag>
  );
}

export default SpotlightCard;
